/* eslint-disable @typescript-eslint/no-explicit-any */
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FileText } from "lucide-react";

const TAX_TYPE_TRANSLATIONS: { [key: string]: string } = {
  CREATION: "Criação",
  UPDATE: "Atualização",
  DELETE: "Exclusão",
};

export function ModalSPEDDetails({ requestData }: { requestData: any }) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-4">
          <Label className="text-lg">Email</Label>
          <Input
            value={requestData.email}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-4">
          <Label className="text-lg">Responsável</Label>
          <Input
            value={requestData.responsible}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-4">
          <Label className="text-lg">Tipo de Solicitação</Label>
          <Input
            value={
              TAX_TYPE_TRANSLATIONS[requestData.tax_type_request] ||
              requestData.tax_type_request
            }
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-4">
          <Label className="text-lg">Tipo Fiscal</Label>
          <Input
            value={requestData.type}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-4">
          <Label className="text-lg">Período SPED</Label>
          <Input
            value={`${requestData.sped_values.startDate} - ${requestData.sped_values.endDate}`}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>

        <div className="flex flex-col gap-4">
          <Label className="text-lg">Criado em</Label>
          <Input
            value={format(
              new Date(requestData.created_at),
              "dd/MM/yyyy HH:mm:ss",
              { locale: ptBR }
            )}
            disabled
            className="bg-gray-100 h-12 text-lg"
          />
        </div>
      </div>

      <div className="flex flex-col gap-4">
        <Label className="text-lg">Arquivo SPED</Label>
        <div className="flex items-center gap-3 bg-gray-100 p-4 rounded-md h-14 w-full">
          <FileText className="text-gray-600 w-7 h-7" />
          <span className="text-lg font-medium truncate">
            {requestData.sped_values.fileName}
          </span>
        </div>
      </div>
    </div>
  );
}
